import http from "../../service/data-service";

export default {
  state: {
    caixa: [],
    saldo: 0,
  },
  getters: {
    caixa(state: any) {
      return state.caixa;
    },
    saldo(state: any){
      return state.saldo;
    }
  },
  mutations: {
    setCaixa(state: any, caixa: any) {
      state.caixa = caixa;
    },
    setSaldo(state:any, saldo: any){
      state.saldo = saldo;
    }
  },
  actions: {
    getDadosCaixa({ commit }: { commit: any },payload: any) {
      commit("setCaixa", []);

      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/caixa/findDadosCaixa?nome="+payload.nome+"&tipo="+payload.tipo+"&dataInicial="+payload.dataInicial+"&dataFinal="+payload.dataFinal)
          .then((result: any) => {
            commit("setCaixa", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
  },
};
